import React from 'react';

const Mastercard = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="26"
      viewBox="0 0 42 26"
      fill="none"
      {...props}
    >
      <circle cx="15" cy="13" r="12" fill="#EB001B" />
      <circle cx="27" cy="13" r="12" fill="#F79E1B" />
      <path
        d="M21 3.5C23.7614 5.61612 25.5 8.99494 25.5 12.75C25.5 16.5051 23.7614 19.8839 21 22C18.2386 19.8839 16.5 16.5051 16.5 12.75C16.5 8.99494 18.2386 5.61612 21 3.5Z"
        fill="#FF5F00"
      />
    </svg>
  );
};

export default Mastercard;
